import React from 'react';
import { Screen } from 'src/components/screen';
import { ExpenseProvider } from './expense-context';
import { ExpenseTrackerContainer } from './container';

const ExpenseTrackerScreen: React.FC = () => {
  return (
    <Screen>
      <ExpenseProvider>
        <ExpenseTrackerContainer />
      </ExpenseProvider>
    </Screen>
  );
};

export { ExpenseTrackerScreen };
